import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";

import {
  Card,
  CardBody,
  CardImg,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Label,
  Input,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import { getSchemelist } from "store/scheme/actions";
import { getcycleYearlist } from "store/cycle/actions";

import { isEmpty, size } from "lodash";
import "assets/scss/table.scss";
import moment from "moment";

class CycleYearReport extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      idFilter: "",
      nameFilter: "",
      priceFilter: "",
      dateofadditionFilter: "",
      schemes: [],
      structuredData: [],
      noofanalytesFilter: "",
      participants: [],
      filteredParticipants: [],
      addedbyFilter: "",
      statusFilter: "",
      analytetypeFilter: "",
      SchemeList: [],
      schemeNameDropdownFilter: "",
      selectedSchemeId: "",
      selectedCycleId: "",
      addedByDropdownFilter: "",
      cycleFilterSelected: {
        last_cycle: false,
        current_cycle: false,
        next_cycle: false,
        renewal_Cycle: false,
      },
      analyte: "",
      modal: false,
      selectedParticipants: [],
      LabModal: false,
      modalSchemeName: "",
      AllLabs: [],
      deleteModal: false,
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      schemeFilters: {},
      provinceFilter: "",
      cityFilter: "",
      districtFilter: "",
      registered_at: "",
      filteredStructuredData: [],
    };
  }

  componentDidMount() {
    const { user_id } = this.state;
    if (!user_id) return;

    const { onGetCycleYearList, onGetScheme } = this.props;
    onGetCycleYearList(user_id);
    this.fetchData(user_id);
    onGetScheme(user_id);
  }

  fetchData(user_id) {
    const { onGetCycleYearList } = this.props;
    if (onGetCycleYearList) onGetCycleYearList(user_id);
  }
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;
    this.setState({ [filterName]: value }, () =>
      this.setState({ filteredStructuredData: this.filterStructuredData() })
    );
  };

  componentDidUpdate(prevProps) {
    const { CycleList } = this.props;
    if (
      prevProps.CycleList !== CycleList &&
      Array.isArray(CycleList?.schemes)
    ) {
      const newStructured = [];

      // Iterate each scheme
      CycleList.schemes.forEach(scheme => {
        const schemeId = scheme.scheme_id;
        const schemeName = scheme.scheme_name;
        const cyclesArr = scheme.cycles || [];

        cyclesArr.forEach((cycle, cycleIndex) => {
          const reportstatus = (cycle.reportstatus || "").toString().trim();
          let category = "current_cycle";
          if (reportstatus === "Old") category = "last_cycle";
          else if (reportstatus === "Previous") category = "current_cycle";
          else if (reportstatus === "New") category = "next_cycle";
          // let category = null;

          // if (reportstatus === "Previous") category = "current_cycle";
          // else if (reportstatus === "New") category = "next_cycle";

          // // Skip OLD cycles entirely
          // if (!category) return;
          // // Build a set of participant IDs for the NEXT cycle
          const nextCycle = cyclesArr[cycleIndex + 1];
          const nextIdsSet = new Set(
            (nextCycle?.participants || []).map(pp => pp.id)
          );

          // Add CURRENT participants
          (cycle.participants || []).forEach(p => {
            const isInNext = nextIdsSet.has(p.id);

            // Determine category
            let participantCategory = category;

            // Push participant into structured data
            newStructured.push({
              scheme_id: schemeId,
              schemeName: schemeName,
              cycle_id: cycle.cycle_id,
              cycleNo: cycle.cycle_no,
              category: participantCategory,
              reportstatus,
              id: p.id,
              registered_at: p.registered_at,
              name: p.name || p.lab_name || "",
              province: p.province || "",
              city: p.city || "",
              district: p.district || "",
              payment_details: p.payment_details || {},
              rawParticipant: p,
              existsInNext: isInNext,
              fromCycle: true,
            });

            // Add Renewal row ONLY for counts (optional)
            if (category === "current_cycle" && !isInNext) {
              newStructured.push({
                scheme_id: schemeId,
                schemeName: schemeName,
                cycle_id: cycle.cycle_id,
                cycleNo: cycle.cycle_no,
                category: "renewal_Cycle",
                reportstatus: "renewal",
                id: p.id,
                registered_at: p.registered_at,
                name: p.name || p.lab_name || "",
                province: p.province || "",
                city: p.city || "",
                district: p.district || "",
                payment_details: p.payment_details || {},
                rawParticipant: p,
                existsInNext: false, // Red in modal
                fromCycle: false,
              });
            }
          });
        });
      });

      this.setState({
        structuredData: newStructured,
        filteredStructuredData: newStructured.slice(),
      });
    }
  }

  filterStructuredData = () => {
    const {
      structuredData,
      selectedSchemeId,
      selectedCycleId,
      provinceFilter,
      cityFilter,
      districtFilter,
      cycleFilterSelected,
    } = this.state;

    const pFilter = (provinceFilter || "").toLowerCase();
    const cFilter = (cityFilter || "").toLowerCase();
    const dFilter = (districtFilter || "").toLowerCase();

    const selectedCategories = Object.keys(cycleFilterSelected).filter(
      k => cycleFilterSelected[k]
    );

    return structuredData.filter(entry => {
      if (pFilter && !(entry.province || "").toLowerCase().includes(pFilter))
        return false;
      if (cFilter && !(entry.city || "").toLowerCase().includes(cFilter))
        return false;
      if (dFilter && !(entry.district || "").toLowerCase().includes(dFilter))
        return false;
      if (
        selectedSchemeId &&
        parseInt(selectedSchemeId, 10) !== parseInt(entry.scheme_id, 10)
      )
        return false;
      if (
        selectedCycleId &&
        parseInt(selectedCycleId, 10) !== parseInt(entry.cycle_id, 10)
      )
        return false;
      if (
        selectedCategories.length > 0 &&
        !selectedCategories.includes(entry.category)
      )
        return false;

      return true;
    });
  };

  handleCycleFilterChange = type => {
    this.setState(
      prevState => ({
        cycleFilterSelected: {
          ...prevState.cycleFilterSelected,
          [type]: !prevState.cycleFilterSelected[type], // toggle only clicked checkbox
        },
      }),
      () => {
        const filtered = this.filterStructuredData();
        this.setState({ filteredStructuredData: filtered });
      }
    );
  };

  aggregateStructuredData = data => {
    const locationMap = {};
    const uniqueMap = {}; // NEW — track unique participants per category & location

    data.forEach(p => {
      const locKey = `${p.province}||${p.city}||${p.district}`;
      const uniqueKey = `${locKey}||${p.id}||${p.category}`;

      if (!locationMap[locKey]) {
        locationMap[locKey] = {
          rowId: locKey,
          province: p.province,
          city: p.city,
          district: p.district,
          last_cycle: 0,
          current_cycle: 0,
          next_cycle: 0,
          renewal_Cycle: 0,
        };
      }

      // Skip if this participant-category is already counted
      if (uniqueMap[uniqueKey]) return;
      uniqueMap[uniqueKey] = true;

      // Count 1 participant per category per location
      locationMap[locKey][p.category] += 1;
    });

    return Object.values(locationMap);
  };

  getUniqueParticipantCount(data, category) {
    const ids = new Set();
    data.forEach(item => {
      if (item.category === category) {
        ids.add(item.id);
      }
    });
    return ids.size;
  }
  generateColumns() {
    const { cycleFilterSelected } = this.state;

    // Multiple selected checkboxes
    const selectedTypes = Object.keys(cycleFilterSelected).filter(
      k => cycleFilterSelected[k]
    );

    const filteredData = this.filterStructuredData();

    const totalLast = this.getUniqueParticipantCount(
      filteredData,
      "last_cycle"
    );
    const totalCurrent = this.getUniqueParticipantCount(
      filteredData,
      "current_cycle"
    );
    const totalNew = this.getUniqueParticipantCount(filteredData, "next_cycle");
    const totalRenewal = this.getUniqueParticipantCount(
      filteredData,
      "renewal_Cycle"
    );

    const createCycleColumn = (field, text, total, isRenewal = false) => ({
      dataField: field,
      text,
      formatter: (cell, row) => {
        const color = isRenewal ? "red" : "blue";

        const handleClick = () => {
          if (isRenewal) this.handleCycleClick(row, field);
          else this.openCountModal(row, null, field);
        };

        return (
          <span
            style={{
              color,
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={handleClick}
          >
            {row[field] || "-"}
          </span>
        );
      },
      headerFormatter: () => (
        <div style={{ textAlign: "center" }}>
          <div style={{ fontWeight: "bold" }}>{text}</div>
          <div style={{ fontSize: "12px", color: isRenewal ? "red" : "#555" }}>
            Total: {total}
          </div>
        </div>
      ),
      style: { textAlign: "center" },
    });

    // Always show location columns
    let columns = [
      {
        dataField: "province",
        text: "Province",
        style: { textAlign: "center" },
      },
      { dataField: "city", text: "City", style: { textAlign: "center" } },
      {
        dataField: "district",
        text: "District",
        style: { textAlign: "center" },
      },
    ];

    // If no checkbox selected → show all cycle columns
    const showAll = selectedTypes.length === 0;

    if (showAll || selectedTypes.includes("last_cycle"))
      columns.push(createCycleColumn("last_cycle", "Last Cycle", totalLast));

    if (showAll || selectedTypes.includes("current_cycle"))
      columns.push(
        createCycleColumn("current_cycle", "Current Cycle", totalCurrent)
      );

    if (showAll || selectedTypes.includes("next_cycle"))
      columns.push(createCycleColumn("next_cycle", "Next Cycle", totalNew));

    if (showAll || selectedTypes.includes("renewal_Cycle"))
      columns.push(
        createCycleColumn("renewal_Cycle", "Renewal", totalRenewal, true)
      );

    return columns;
  }

  handleCycleClick = (row, field) => {
    const org = this.props.match.params.organization_name;
    const user_id = this.state.user_id;

    // Pass selected province/city/district + cycle type
    this.props.history.push({
      pathname: `/${org}/RenewalParticipant/${user_id}`,
      state: {
        cycleType: field, // current_cycle / next_cycle / renewal_Cycle / last_cycle
        province: row.province,
        city: row.city,
        district: row.district,
      },
    });
  };

  formatDate = dateStr => {
    if (!dateStr) return "-";

    const date = new Date(dateStr);
    if (isNaN(date)) return "-";

    const day = String(date.getDate()).padStart(2, "-");
    const month = date.toLocaleString("en-US", { month: "short" });
    const year = String(date.getFullYear()).slice(2);

    return `${day}-${month}-${year}`;
  };
  openCountModal = (row, selectedSchemeId = null, cycleCategory = null) => {
    const { structuredData, selectedSchemeId: activeSchemeId } = this.state;
    const schemeIdToFilter = selectedSchemeId || activeSchemeId;

    // Filter participants by location and category
    const participantsInLocation = structuredData.filter(p => {
      const matchProvince = p.province === row.province;
      const matchCity = p.city === row.city;
      const matchDistrict = p.district === row.district;
      const matchCategory = cycleCategory ? p.category === cycleCategory : true;
      const matchScheme = schemeIdToFilter
        ? parseInt(p.scheme_id, 10) === parseInt(schemeIdToFilter, 10)
        : true;

      return (
        matchProvince &&
        matchCity &&
        matchDistrict &&
        matchCategory &&
        matchScheme
      );
    });

    // Aggregate single row per participant
    const participantMap = {};

    participantsInLocation.forEach(p => {
      const id = p.id;

      if (!participantMap[id]) {
        participantMap[id] = {
          id,
          name: p.participantName || p.name || "Unnamed Lab",
          totalSchemes: 0,
          payments: [], // reset payments array
          existsInNext: p.existsInNext || false,
          category: p.category,
          registered_at: p.registered_at,
        };
      }

      participantMap[id].totalSchemes += 1;

      // Add payment details
      const pay = p.payment_details || {};
      if (
        pay.payment_id &&
        !participantMap[id].payments.find(x => x.payment_id === pay.payment_id)
      ) {
        participantMap[id].payments.push({
          payment_id: pay.payment_id,
          price: pay.price ? Number(pay.price).toLocaleString() : "-", // format with commas
          paydate: pay.paydate ? this.formatDate(pay.paydate) : "-",
        });
      }

      // If participant exists in next cycle, mark it
      if (p.existsInNext) participantMap[id].existsInNext = true;
    });

    // Prepare selected participants with color info
    const selectedParticipants = Object.values(participantMap).map(p => {
      let color = "#000"; // default black text

      // For CURRENT cycle: red if not renewed
      if (p.category === "current_cycle" && !p.existsInNext) {
        color = "#c0392b"; // red
      }

      // Renewal rows are always red
      if (p.category === "renewal_Cycle") {
        color = "#c0392b";
      }

      return { ...p, color };
    });

    this.setState({
      selectedParticipants,
      modalProvince: row.province || "-",
      modalCity: row.city || "-",
      modalDistrict: row.district || "-",
      modalSchemeName: schemeIdToFilter
        ? this.props.SchemeList.find(
            s => parseInt(s.id, 10) === parseInt(schemeIdToFilter, 10)
          )?.name
        : "All",
      LabModal: true,
    });
  };

  toggleLabModal = () => {
    this.setState(prevState => ({ LabModal: !prevState.LabModal }));
  };

  render() {
    const { SchemeList } = this.props;
    const { provinceFilter, cityFilter, districtFilter } = this.state;

    if (!this.state.structuredData || this.state.structuredData.length === 0) {
      return <div>Loading...</div>;
    }
    const filteredData = this.filterStructuredData();
    const dataForTable = this.aggregateStructuredData(filteredData);
    const allColumns = this.generateColumns();
    // const dataForTable = this.aggregateStructuredData();

    const provinces = [
      ...new Set(dataForTable.map(item => item.province).filter(Boolean)),
    ];
    const districts = [
      ...new Set(dataForTable.map(item => item.district).filter(Boolean)),
    ];

    const defaultSorted = [{ dataField: "province", order: "asc" }];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Scheme List | NEQAS</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
              title="Participants Renewal Report"
              breadcrumbItem="Participants Renewal Report"
            />
            <Row className="justify-content-center">
              <div style={{ fontSize: "14px", marginBottom: "6px" }}>
                <strong style={{ fontSize: "16px" }}>Note</strong>
                <div
                  style={{
                    marginTop: "2px",
                    display: "grid",
                    gridTemplateColumns: "110px auto",
                    lineHeight: "1.15",
                  }}
                >
                  <div style={{ paddingLeft: "8px" }}>
                    <strong>CURRENT:</strong>
                  </div>
                  <div>
                    Paid for a scheme with a cycle marked <em>Previous</em>
                  </div>

                  <div style={{ paddingLeft: "8px" }}>
                    <strong>NEXT:</strong>
                  </div>
                  <div>
                    Paid for a scheme with cycle(s) but no rounds issued
                  </div>

                  <div style={{ paddingLeft: "8px" }}>
                    <strong>RENEWAL:</strong>
                  </div>
                  <div>
                    Paid for a scheme with cycle(s) marked <em>Previous</em> but
                    not for cycle marked <em>New</em>
                  </div>
                  <div style={{ paddingLeft: "8px" }}>
                    <strong>LAST:</strong>
                  </div>
                  <div>
                    Paid for a scheme with cycle(s) marked <em>Old</em> where
                    all rounds have been issued and the cycle end date has
                    passed
                  </div>
                </div>
              </div>

              <Col lg="10">
                <Card>
                  <CardBody>
                    <div className="mb-4 p-3 border rounded bg-light">
                      <Row>
                        <Col md="2">
                          <Label for="provinceFilter">Province</Label>
                          <Input
                            type="select"
                            value={provinceFilter}
                            onChange={e =>
                              this.handleFilterChange("provinceFilter", e)
                            }
                          >
                            <option value="">All Provinces</option>
                            {provinces.map((p, i) => (
                              <option key={i} value={p}>
                                {p}
                              </option>
                            ))}
                          </Input>
                        </Col>
                        <Col md="2">
                          <Label for="districtFilter">District</Label>
                          <Input
                            type="select"
                            value={districtFilter}
                            onChange={e =>
                              this.handleFilterChange("districtFilter", e)
                            }
                          >
                            <option value="">All Districts</option>
                            {districts.map((d, i) => (
                              <option key={i} value={d}>
                                {d}
                              </option>
                            ))}
                          </Input>
                        </Col>
                        <Col md="2">
                          <Label for="schemeSelect">Scheme</Label>
                          <Input
                            type="select"
                            value={this.state.selectedSchemeId}
                            onChange={e =>
                              this.setState(
                                {
                                  selectedSchemeId: e.target.value,
                                  selectedCycleId: "",
                                },
                                () =>
                                  this.setState({
                                    filteredStructuredData:
                                      this.filterStructuredData(),
                                  })
                              )
                            }
                          >
                            <option value="">All Schemes</option>
                            {SchemeList.map(s => (
                              <option key={s.id} value={s.id}>
                                {s.name}
                              </option>
                            ))}
                          </Input>
                        </Col>
                        <Col md="6" className="d-flex align-items-center">
                          {[
                            "last_cycle",
                            "current_cycle",
                            "next_cycle",
                            "renewal_Cycle",
                          ].map(type => (
                            <label
                              key={type}
                              style={{
                                marginRight: "15px",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={this.state.cycleFilterSelected[type]}
                                onChange={() =>
                                  this.handleCycleFilterChange(type)
                                }
                                style={{ marginRight: "5px" }}
                              />
                              {type.replace("_", " ").toUpperCase()}
                            </label>
                          ))}
                        </Col>
                      </Row>
                    </div>

                    <PaginationProvider
                      pagination={paginationFactory({
                        sizePerPage: 50,
                        totalSize: dataForTable.length,
                        showTotal: true,
                        custom: true,
                      })}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="rowId"
                          data={dataForTable}
                          columns={allColumns}
                          search
                        >
                          {toolkitProps => (
                            <div>
                              <div className="table-responsive">
                                <BootstrapTable
                                  bootstrap4
                                  bordered
                                  hover
                                  striped
                                  headerWrapperClasses="table-light"
                                  defaultSorted={defaultSorted}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  filter={filterFactory()}
                                />
                              </div>

                              <Modal
                                isOpen={this.state.LabModal}
                                toggle={this.toggleLabModal}
                                style={{ maxWidth: "1000px", width: "80%" }}
                              >
                                <ModalHeader
                                  toggle={this.toggleLabModal}
                                  tag="h4"
                                >
                                  Participants in {this.state.modalProvince},{" "}
                                  {this.state.modalDistrict},{" "}
                                  {this.state.modalCity} for{" "}
                                  <strong>{this.state.modalSchemeName}</strong>
                                </ModalHeader>
                                <ModalBody>
                                  {this.state.selectedParticipants.length ===
                                  0 ? (
                                    <p>
                                      No participants found in this location.
                                    </p>
                                  ) : (
                                    <div
                                      style={{
                                        maxHeight: "400px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr>
                                            <th
                                              className="text-center"
                                              style={{
                                                backgroundColor: "#e0f7fa",
                                              }}
                                            >
                                              Joining Date
                                            </th>
                                            <th
                                              className="text-center"
                                              style={{
                                                backgroundColor: "#f1f8e9",
                                              }}
                                            >
                                              Participant Name
                                            </th>
                                            <th
                                              className="text-center"
                                              style={{
                                                backgroundColor: "#fff9c4",
                                              }}
                                            >
                                              Total Schemes
                                            </th>
                                            <th
                                              className="text-center"
                                              style={{
                                                backgroundColor: "#e7e4ff",
                                              }}
                                            >
                                              Paid Amount
                                            </th>
                                            <th
                                              className="text-center"
                                              style={{
                                                backgroundColor: "#f5ebd8",
                                              }}
                                            >
                                              Payment Date
                                            </th>
                                          </tr>
                                        </thead>

                                        <tbody>
                                          {this.state.selectedParticipants.map(
                                            (p, idx) => (
                                              <tr
                                                key={idx}
                                                style={{ color: p.color }}
                                              >
                                                <td
                                                  style={{
                                                    backgroundColor: "#e0f7fa",
                                                  }}
                                                >
                                                  {this.formatDate(
                                                    p.registered_at
                                                  )}
                                                </td>
                                                <td
                                                  style={{
                                                    backgroundColor: "#f1f8e9",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  {p.name}
                                                </td>
                                                <td
                                                  style={{
                                                    backgroundColor: "#fff9c4",
                                                  }}
                                                >
                                                  {p.totalSchemes}
                                                </td>
                                                <td
                                                  style={{
                                                    backgroundColor: "#e7e4ff",
                                                    textAlign: "right",
                                                  }}
                                                >
                                                  {p.payments.map((x, i) => (
                                                    <div key={i}>
                                                      {x.price ?? "-"}
                                                    </div>
                                                  ))}
                                                </td>
                                                <td
                                                  style={{
                                                    backgroundColor: "#f5ebd8",
                                                  }}
                                                >
                                                  {p.payments.map((x, i) => (
                                                    <div key={i}>
                                                      {x.paydate}
                                                    </div>
                                                  ))}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  )}
                                </ModalBody>
                              </Modal>

                              <PaginationListStandalone {...paginationProps} />
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

CycleYearReport.propTypes = {
  match: PropTypes.object,
  AllLabs: PropTypes.array,
  SchemeList: PropTypes.array,
  className: PropTypes.any,
  createInstrumentType: PropTypes.array,
  onGetCycleParticipants: PropTypes.func.isRequired,
  onGetScheme: PropTypes.func,
  onGetCycleYearList: PropTypes.func,
  history: PropTypes.object.isRequired,
  CycleList: PropTypes.array,
};

const mapStateToProps = state => {
  const AllLabs = state.registrationAdmin.AllLabs || [];
  const CycleYearList = state.CycleList?.CycleYearList || {};

  const SchemeList =
    (CycleYearList.schemes || []).map(s => ({
      id: s.scheme_id,
      name: s.scheme_name,
      cycles: s.cycles || [],
    })) || [];

  return {
    SchemeList,
    AllLabs,
    CycleList: CycleYearList,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onGetScheme: id => dispatch(getSchemelist(id)),
  onGetCycleYearList: id => dispatch(getcycleYearlist(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CycleYearReport));
